import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/images/8T6A0876.jpg";

const CsrShowcase = () => {
  return (
    <section className="bg-ofWhite text-white1 py-16 sm:py-20">
      <div className="max-w-6xl mx-auto px-4 lg:px-0 space-y-12">
        <div className="relative overflow-hidden rounded-3xl shadow-lg min-h-[420px] md:min-h-0">
          <img
            src={heroImage}
            alt="Transforming Rural India"
            className="w-full h-[420px] lg:h-[460px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/45 to-black/30" />
          <div className="absolute inset-0 flex z-10 items-end">
            <div className="flex flex-col h-full px-4 py-5 sm:px-5 sm:py-6 md:px-10 lg:px-12">
              <div className="w-full sm:max-w-sm bg-black/60 backdrop-blur-md rounded-[28px] px-4 md:px-8 py-5 md:py-8 text-white3 shadow-2xl">
                <p className="text-[0.5rem] font-semibold uppercase tracking-[0.18em] text-white mb-0 whitespace-nowrap sm:hidden">
                  Transforming Rural India — One Family at a Time
                </p>
                <p className="hidden sm:block text-sm font-light uppercase tracking-[0.25em] text-white mb-4">
                  Transforming Rural India — One Family at a Time
                </p>
                <div className="hidden sm:block space-y-3">
                  <h2 className="text-2xl lg:text-3xl font-semibold leading-tight">
                    Our CSR programmes uplift families, educate children and
                    deliver healthcare where it’s needed most.
                  </h2>
                  <p className="text-sm lg:text-base text-white/80">
                    Step inside the stories that make BSS Sonata Microcredit
                    more than a financial partner — a community ally.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Link
            to="/csr"
            className="absolute bottom-4 left-1/2 -translate-x-1/2 sm:left-auto sm:right-6 sm:translate-x-0 sm:bottom-6 z-20 inline-flex items-center justify-center px-8 sm:px-6 py-3 rounded-full bg-white3 text-primary font-semibold shadow-lg hover:bg-white2 transition-colors text-sm sm:text-base whitespace-nowrap w-full max-w-xs sm:max-w-none sm:w-auto"
          >
            Discover Our CSR Story
            <span className="ml-2 text-lg" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CsrShowcase;
